

















import Vue from "vue";
import Introduction from "./Introduction.vue";
import IntroductionForFaceUp from "./IntroductionForFaceUp.vue";
import { ChallengeDetails } from "@/js/RemoteStarter";
import { RemoteStarter } from "@/js/RemoteStarter";
import { Utils } from "@/js/Utils";

export default Vue.extend({
  name: "Welcome",
  components: {
    Introduction,
    IntroductionForFaceUp
  },
  props: {
    ready: Boolean
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async start(): Promise<void> {
      this.loading = true;
      const self: any = this;
      const videoInputDevice = await Utils.getVideoInputDevice();
      RemoteStarter.startChallenge(
        videoInputDevice,
        function(challengeDetails: ChallengeDetails) {
          // Make sure all models are loaded
          Promise.all((window as any).modelPromises).then(function() {
            self.$emit("challenge-details", challengeDetails);
          });
        },
        function(error: Error) {
          self.$emit("error", error);
        }
      );
    }
  },
  computed: {
    isFaceUpChallenge() {
      return Utils.getChallengeType() === "faceup";
    }
  }
});
